(function () {
  'use strict';

  angular
    .module('crewViolations')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewViolations', {
        url: '/crew-violations',
        views: {
          'crewViolationsView': {
            templateUrl: 'crew-violations/views/crew-violations.tpl.html',
            controller: 'CrewViolationsCtrl',
            controllerAs: 'crewViolations'
          }
        }
      });
  }
}());
